
const nameList = [
    {
        entityField: "btName",
        showField: "分类名称",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "btDesc",
        showField: "描述",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 130,
        fieldType: "string",

    },


]


const storeList = [

    {
        entityField: "bgmCode",
        showField: "商品编码",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "bgmName",
        showField: "通用名字",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "retailPrice",
        showField: "统一零售价",
        fieldWeight: 100,
        fieldType: "string",

    },





    {
        entityField: "manufacturer",
        showField: "生产商",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "placeorigin",
        showField: "产地",
        fieldWeight: 100,
        fieldType: "string",

    },

]
const searchList = [
    {
        showField: "分类名称",
        entityField: "btName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

]
const searchList2 = [
 
    {
        showField: "通用名称",
        entityField: "bgmName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

]





export { nameList, storeList, searchList, searchList2 }